import React from 'react'

import { Input, Label } from './Checkbox.styles'

/**
 *
 */
// @ts-expect-error TS(7031) FIXME: Binding element 'id' implicitly has an 'any' type.
const Checkbox = ({ id, name, value, label, checked, onChange }) => (
  <>
    <Input
      type="checkbox"
      id={id}
      name={name}
      value={value}
      checked={checked}
      onChange={onChange}
    />
    <Label htmlFor={id}>{label}</Label>
  </>
)

export default Checkbox
